export default __webpack_public_path__ + "6b1cf2d57a303a3c5a03c770548c8dc9.svg";